// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle___5xfW"};